import { render, staticRenderFns } from "./CostBearerDepositInvoiceDocumentPreview.vue?vue&type=template&id=637f62b3&scoped=true"
import script from "./CostBearerDepositInvoiceDocumentPreview.vue?vue&type=script&lang=ts"
export * from "./CostBearerDepositInvoiceDocumentPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f62b3",
  null
  
)

export default component.exports